// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */.options{position:absolute;right:0;z-index:2}`, "",{"version":3,"sources":["webpack://./packages/builder-setup/estimating/components/component-details-tab-container/component-details-tab-container.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAKA,SACE,iBAAA,CACA,OAAA,CACA,SAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n.options {\n  position: absolute;\n  right: 0;\n  z-index: 2;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
